import { ISuperdatProduct, ISuperdatProductState } from '../@type';
import { CREATE_SUPERDAT_PRODUCT } from '../constants';
import superdatProductServices from '../service';
('../service');
import { createAsyncThunk, ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { superdatProductActions } from '../_redux/index';

export const createSuperdatProduct = createAsyncThunk<
  any,
  { id: number; content: string; replyId: number },
  ThunkAPIConfig
>(CREATE_SUPERDAT_PRODUCT, async (args, { dispatch, rejectWithValue }) => {
  try {
    const { data } = await superdatProductServices.createSuperdatProductList(
      args as any
    );

    dispatch(
      superdatProductActions.getSuperdatProducts({
        page: 1,
        limit: 5
      })
    );
    return {
      data
    };
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const createSuperdatProductBuilder = (
  builder: ActionReducerMapBuilder<ISuperdatProductState>
) => {
  const { pending, fulfilled, rejected } = createSuperdatProduct;
  builder
    .addCase(pending, draftState => {
      draftState.loading = true;
    })
    .addCase(fulfilled, (draftState, action) => {
      const { data } = action.payload;
      draftState.loading = false;
    })
    .addCase(rejected, draftState => {
      draftState.loading = false;
    });
};
